// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3r-0";
export var eligibilityCardNotEligible = "_3r-1";